// @view/panels/document/review/SectionActions.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { OptionTs } from "@ps-bridge/interop";
import type { SectionActionsPhase } from "@ps-bridge/models/ui/sectionActionsPhase";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import SectionActionsDraftView from "@view/document/review/SectionActionsDraft.view";
import SectionActionsContentView from "@view/document/review/SectionActionsContent.view";

type SectionActionsPanelProps = {
  phase: SectionActionsPhase;
  sectionContents: OptionTs<string>;
} & Pick<DocumentReviewViewProps, "handleDraft" | "handleRefine" | "handleEdits" | "handleUpload">;

const SectionActionsPanel: React.FC<SectionActionsPanelProps> = ({
  phase,
  sectionContents,
  handleDraft,
  handleRefine,
  handleEdits,
  handleUpload,
}) => {
  const phaseKeys = {
    hidden: "hidden",
    draft: "draft",
    content: "content",
  } as const satisfies Record<SectionActionsPhase, SectionActionsPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.draft]: <SectionActionsDraftView handleDraft={handleDraft} />,
    [phaseKeys.content]: (
      <SectionActionsContentView
        sectionContents={sectionContents}
        handleRefine={handleRefine}
        handleEdits={handleEdits}
        handleUpload={handleUpload}
      />
    ),
  } as const satisfies Record<SectionActionsPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(SectionActionsPanel);
